import {
  getMailTemplates, createMailTemplate, updateMailTemplate, deleteMailTemplate, getMailTemplateFields, sendMail, getAutoMail, createAutoMail, updateAutoMail, deleteAutoMail,
} from '@/api/sms'

export default {
  FETCH_MAIL_TEMPLATES({ commit }, data) {
    return new Promise((resolve, reject) => {
      getMailTemplates(data).then(response => {
        commit('SET_MAIL_TEMPLATES', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  ADD_SMS_TEMPLATE(_, data) {
    return createMailTemplate(data)
  },
  EDIT_SMS_TEMPLATE(_, data) {
    return updateMailTemplate(data)
  },
  DELETE_SMS_TEMPLATE(_, data) {
    return deleteMailTemplate(data)
  },
  FETCH_SMS_TEMPLATE_FIELDS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getMailTemplateFields(data).then(response => {
        commit('SET_SMS_TEMPLATE_FIELDS', response.data)
        resolve(response.data.results)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  SEND_SMS(_, data) {
    return sendMail(data)
  },
  FETCH_AUTO_MAILS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getAutoMail(data).then(response => {
        commit('SET_AUTO_MAILS', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  ADD_AUTO_SMS(_, data) {
    return createAutoMail(data)
  },
  EDIT_AUTO_SMS(_, data) {
    return updateAutoMail(data)
  },
  DELETE_AUTO_SMS(_, data) {
    return deleteAutoMail(data)
  },
}
